"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ChevronRightMedium;

var _ChevronRightMedium = require("@adobe/react-spectrum-ui/dist/ChevronRightMedium");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ChevronRightMedium(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ChevronRightMedium.ChevronRightMedium, null));
}